import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, map, catchError, throwError } from 'rxjs';

const excludedEndpoints: string[] = ['assets'];

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (excludedEndpoints.some((ep) => req.url.includes(ep))) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      'x-api-key': environment.apiKey,
    },
  });  

  return next(authReq).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const originalBody = event.body as any;
        const customResponse = event.clone({
          body: {
            statusCode: event.status,
            ...originalBody,
          },
        });

        return customResponse;
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.error) {
        return throwError(() => ({
          statusCode: error.status,
          error: error.error.error,
        }));
      }

      return throwError(
        () => error
      );
    })
  );
}
